var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"room-promote-card",on:{"click":_vm.promoteRoom}},[_c('img',{attrs:{"alt":"promote-icon","src":require("@/assets/images/room_browser/icon-room-promote.svg")}}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('message.promo_card.promote_room'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }